import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { GameThemeService } from '../service/game-theme.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const backendApiUrl = inject(GameThemeService).getBackendApiUrl();

  if (req.url.startsWith(backendApiUrl) && authService.hasValidAccessToken()) {
    const token = authService.oAuthService!.getAccessToken();

    if (token) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
      return next(authReq);
    }
  }

  return next(req);
};
